import { gql } from '@apollo/client'

export const Query = gql`
  query Asset($companyId: ID!, $filters: AssetFilters) {
    assets(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        barcode {
          id
          barcode
        }
        serialNumber
        warehouse {
          id
          name
        }
        assetType {
          id
          name
        }
        notes
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
